import React, { memo, useState } from 'react';
import Link from 'components/Link';
// import AdCaller from 'helpers/ads/adCaller';
import SocialSharingWeb from 'routes/articleshow_v2/components/desktop/SocialSharingWeb';
import s from './MainHeader.scss';
import { TOI_IMAGE_DOMAIN, TOI_LIVE_DOMAIN } from '../../../../constants';
import BreakingNewsHeadline from '../BreakingNewsHeadline/BreakingNewsHeadline';
import SocialSharingMobile from '../../../../routes/articleshow_v2/components/mobile/SocialSharingMobile/SocialSharingMobile';
import ErrorBoundary from '../../../ErrorBoundary/ErrorBoundary';

const MainHeader = ({
  hideETheading,
  displaytext,
  path,
  // isPowerByAd,
  // isPowerByAdActive,
  hideHeading,
  hideDisplayText,
  hideSharing,
  isWapView,
  breakingnews,
  hideLink,
  shareTitle,
}) => {
  const [showSharing, setShowSharing] = useState(false);
  return (
    <div className={s.electionHeader}>
      {!hideETheading && (
        <div className={s.ETheader}>
          <span className={s.ETheading}>
            {displaytext || `Assembly Elections 2023`}
          </span>
          <span className={s.logo}>
            <img src={`${TOI_IMAGE_DOMAIN}/photo/82253493.cms`} alt="" />
          </span>
        </div>
      )}

      {/* {isPowerByAd && (
        <div className={s.pwdByWrap}>
          <span className={s.sponsoredText}>Sponsored By</span>
          <div className={isPowerByAdActive ? s.pwdByAd : ''}>
            <AdCaller
              data={{
                name: 'electionPowerby',
                ...isPowerByAd,
              }}
              immediateLoad
            />
          </div>
        </div>
      )} */}

      {hideETheading &&
        !hideDisplayText && (
          <div className={s.electionTitleWrap}>
            {
              <Link
                to={path}
                className={s.tagLine}
                data-newga={`click-ElectionWidget#${path}`}
                target="_blank"
                onClick={
                  hideLink
                    ? e => {
                        e.preventDefault();
                      }
                    : null
                }
                ga4Data={[
                  {
                    event: 'user_click',
                    type: 'exitpoll_widget',
                    category: 'Assembly Elections',
                    label: displaytext || `Assembly Elections 2023`,
                  },
                ]}
              >
                {displaytext || `Assembly Elections 2023`}
              </Link>
            }
            {!hideSharing && (
              <>
                {isWapView && (
                  <ErrorBoundary>
                    <SocialSharingMobile
                      title={
                        shareTitle ||
                        'Election Dates, Exit polls, Opinion Poll and Results'
                      }
                      textRequired={false}
                      url={path || `${TOI_LIVE_DOMAIN}/elections`}
                      disableShortUrl
                      linkeDin
                      via="@timesofindia"
                      gaAction="Click"
                      gaCategory="Election_Widget_Homepage"
                      topsticky
                      defaultEmailView
                      ga4Data={{
                        event: 'user_click',
                        type: 'exitpoll_widget',
                        category: 'social_media_links',
                      }}
                      isTablet={false}
                      hideSharingButtons
                      hideSharingNative
                      placeHolderStyles={{ minHeight: '24px' }}
                      placeHolderLoaderClass="follow_us_loader"
                      hideFollow
                    />
                  </ErrorBoundary>
                )}
                {!isWapView && (
                  <div
                    className={`${s.timelineshare} icon_share_wrap`}
                    // onClick={isWapView && socialWidgetToggle}
                    onMouseEnter={() => setShowSharing(!showSharing)}
                    onMouseLeave={() => setShowSharing(!showSharing)}
                  >
                    <div className={`${s.icon_share}`}>
                      <i
                        className={`${s.shareicon} ${
                          showSharing ? s.active : ''
                        }`}
                      />
                      <span>Share</span>
                    </div>

                    {showSharing && (
                      <div className={`${s.shareWrap}`}>
                        <ErrorBoundary>
                          <SocialSharingWeb
                            title={
                              shareTitle ||
                              'Election Dates, Exit polls, Opinion Poll and Results'
                            }
                            textRequired={false}
                            url={path || `${TOI_LIVE_DOMAIN}/elections`}
                            disableShortUrl
                            linkeDin
                            via="@timesofindia"
                            gaAction="Click"
                            gaCategory="Election_Widget_Homepage"
                            topsticky
                            defaultEmailView
                            ga4Data={{
                              event: 'user_click',
                              type: 'exitpoll_widget',
                              category: 'social_media_links',
                            }}
                          />
                        </ErrorBoundary>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      {!hideHeading && <BreakingNewsHeadline breakingnews={breakingnews} />}
    </div>
  );
};

export default memo(MainHeader);
